/**
 * Lightweight Whatflow visibility guard.
 * CSS in bm7-chatbot.css handles positioning; this only un-hides the container
 * if the app injects inline display:none after load. No MutationObserver —
 * watching style mutations while writing styles caused an infinite loop freeze.
 */
(function () {
  function reveal() {
    var c = document.getElementById('whatflow-button-container');
    if (!c) return false;
    if (getComputedStyle(c).display === 'none') {
      c.style.setProperty('display', 'block', 'important');
    }
    return true;
  }

  function start() {
    reveal();
    var tries = 0;
    var timer = setInterval(function () {
      reveal();
      if (++tries >= 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
